var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("titles.default")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("favorites.save"),
                  expression: "$ct('favorites.save')",
                },
              ],
              attrs: { cancel: "" },
              on: {
                click: function ($event) {
                  return _vm.openSaveFavorite()
                },
              },
            },
            [_c("w-fa", { staticClass: "mrs", attrs: { icon: "star" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _c("app-bank-edit-default", {
            ref: "bankEdit",
            attrs: {
              bank: _vm.bank,
              history: _vm.history,
              "clear-batch": _vm.clearBatch,
            },
            on: {
              update: function ($event) {
                return _vm.onUpdate($event)
              },
              valid: function ($event) {
                return _vm.$emit("valid", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }